import { Dialog, Transition } from '@headlessui/react';
import { Fragment, PropsWithChildren } from 'react';
import { FiX } from 'react-icons/fi';

import { cn } from '@/utils';

type Props = PropsWithChildren<{
  closeIconClassName?: string;
  handleClose?: () => void;
  open: boolean;
  contentClassName?: string;
}>;

const SlideOver = ({
  children,
  closeIconClassName = 'text-black',
  contentClassName,
  open,
  handleClose,
}: Props) => {
  const resolveCloseSlideOver = () => {
    if (handleClose) {
      handleClose();
    }

    return null;
  };

  return (
    <Transition.Root as={Fragment} show={open}>
      <Dialog
        as="div"
        className="relative z-10"
        onClose={resolveCloseSlideOver}
      >
        <div className="fixed inset-0" />

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-full">
                  <div className="flex h-full flex-col overflow-y-auto bg-white shadow-xl relative">
                    {handleClose && (
                      <div className="mr-3 flex h-7 absolute right-1 top-4 z-[2]">
                        <button
                          className="relative text-gray-400 hover:text-gray-500 focus:outline-none focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-offset-1 focus-visible:ring-gdt-blue"
                          type="button"
                          onClick={() => handleClose()}
                        >
                          <span className="absolute -inset-2.5" />
                          <span className="sr-only">Close panel</span>
                          <FiX className={cn('w-6 h-6', closeIconClassName)} />
                        </button>
                      </div>
                    )}
                    <div className={cn('relative flex-1', contentClassName)}>
                      {children}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default SlideOver;
